<template>

  <v-card
    max-width="205"
  >
      <v-card-text class="justify-end mb-n4" style="font-size:1.0em" >
        Unknown Email(s)
      </v-card-text>

      <v-card-text>
          <div class ="text-end font-weight-bold" style="font-size:1.0em">
            {{ emails }}
          </div>
      </v-card-text>

  </v-card>

</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'UnknownEmail',
  computed: {
    ...mapGetters({
      emails: 'unknown_email'
    })
  }
}
</script>
